"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaRematriculaProduto = exports.yupRematriculaProduto = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
exports.yupRematriculaProduto = yup.object({
    idRematricula: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Rematricula'),
    idProduto: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Produto'),
    idFormaPagamento: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .integer()
        .label('Forma de Pagamento'),
    desconto: yup.number().min(0).default(0).label('Desconto'),
    parcelas: yup.number().min(0).default(0).label('Numero de Parcelas'),
    tipo: yup.string().default('').max(20, 'Máximo de 20 caracteres.').label('Tipo'),
    primeiroVencimento: (0, utils_1.sge2Date)().default(null).nullable().label('Data do Primeiro Vencimento'),
    manterDesconto: yup.bool().required().default(false).label('Manter o Desconto'),
    valor: yup.number().min(0).default(0).label('Valor'),
    cartao: yup.bool().required().default(false).label('Cartao'),
    juroCartao: yup.number().min(0).default(0).label('Juros do Cartao'),
});
exports.schemaRematriculaProduto = exports.yupRematriculaProduto.shape({});
